import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { DUPLICATE_DMX_DEVICE_PRESETS } from './actionTypes';
import { duplicateDmxDevicePresetsSuccessful, duplicateDmxDevicePresetsFailed } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* duplicateDevicePresets({ payload: { request } }) {
  try {
    const response = yield call(
      dmxAPI.duplicateDevicePresets,
      request.token,
      request.deviceId,
      request.targetDeviceIds,
    );
    if (response.message) {
      yield put(duplicateDmxDevicePresetsSuccessful(response));
    } else throw response.error;
  } catch (error) {
    yield put(duplicateDmxDevicePresetsFailed(error));
  }
}

export function* watchDuplicateDmxDevicePresets() {
  yield takeEvery(DUPLICATE_DMX_DEVICE_PRESETS, duplicateDevicePresets);
}

function* duplicateDmxDevicePresetsSaga() {
  yield all([fork(watchDuplicateDmxDevicePresets)]);
}

export default duplicateDmxDevicePresetsSaga;
